export default "__VITE_PUBLIC_ASSET__aa6c4ead__"